import { Component, inject, OnDestroy } from '@angular/core';
import { PremjestiService } from '@app/components/actions/premjesti-action/premjesti.service';
import { tap } from 'rxjs';

@Component({
  selector: 'app-premjesti-dialog',
  templateUrl: './premjesti-dialog.component.html',
  styleUrls: ['./premjesti-dialog.component.scss']
})
export class PremjestiDialogComponent implements OnDestroy {
  private premjestiService = inject(PremjestiService);

  public dialogVisible = false;

  private visibleSubscription = this.premjestiService.premjestajDialogVisible$
    .pipe(tap((visible) => (this.dialogVisible = visible)))
    .subscribe();

  ngOnDestroy(): void {
    if (this.visibleSubscription) {
      this.visibleSubscription.unsubscribe();
    }
  }

  closeDialog() {
    this.premjestiService.openPremjestanjeDialog(false);
  }
}
